import { take, fork, select, call, put } from "redux-saga/effects";
import { getCurrentStore, getUserInfo } from "../../reducers/app";
import { CODES } from "../../constants";
import API from "../../api/api";
import { toast } from "react-toastify";
// import {globalIntl} from "../App/App";
// import {PAY_STATUS} from "../../reducers/types";

export function* clearLink() {
  yield put({ type: 'CLEAR_LINK_INFO' })
}

function* linkSubmit(data: any): Generator<any, void, any> {
  let userInfo = yield select(getUserInfo)
  let storeId = yield select(getCurrentStore)
  let money: number = parseFloat(data.amt)
  let params = {
    email: userInfo.email,
    clientId: 'h5',
    storeId: storeId,
    amt: money,
    tradeSummary: data.tradeSummary,
    currency: data.currency
  }
  let resp = yield call(API.linkCreate, params)
  if (resp.code === CODES.SUCCESS && resp.data) {
    toast.success(resp.msg)
    yield put({ type: 'SET_LINK_INFO', payload: resp.data })
  } else {
    toast.error(resp.msg)
  }
}

export function* watchLink() {
  while (true) {
    let { payload } = yield take('CREATE_LINK')
    yield fork(linkSubmit, payload.data)
  }
}